import { render, staticRenderFns } from "./BaseButtonPlus.vue?vue&type=template&id=3b4b0ce6&scoped=true&"
import script from "./BaseButtonPlus.vue?vue&type=script&lang=js&"
export * from "./BaseButtonPlus.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonPlus.vue?vue&type=style&index=0&id=3b4b0ce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4b0ce6",
  null
  
)

export default component.exports